/* eslint-disable no-useless-escape */
export const LATITUDE_REGEX = /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,20})?))$/;
export const LONGITUDE_REGEX =
  /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,20})?))$/;
export const NUMBER_REGEX = /^[0-9]*$/;
export const NUMBER_CORRELATIVE_REGEX = /^(0|[0-9][0-9]*)$/;
export const NUMBER_MAXTWO_DECIMALS_REGEX = /^\d+(\.\d{1,2})?$/;
export const VALID_DNIS_REGEX = /^[a-zA-Z0-9]{7,12}$/;
export const FLOAT_MAX_TWO_DECIMALS_REGEX = /^\d+(\.\d{1,2})?$/;
export const FLOAT_REGEX = /^\d+(\.\d{1,})?$/;
export const INT_REGEX = /^[0-9]*$/;
export const VALID_CLIENT_ID_REGEX = /^[a-zA-Z0-9]{1,12}$/;
export const VALID_SKU_REGEX = /^[0-9]{14}$/;
export const VALID_REF_INTERNA_REGEX = /^[a-zA-Z0-9]*$/;
export const VALID_NAME_PROMO_REGEX = /^[A-Za-z0-9ÁÉÍÓÚáéíóúñÑ\-.*’':%+/_ ]*$/;
export const VALID_DESCRIPTION_PROMO_REGEX = /^[A-Za-z0-9ÁÉÍÓÚáéíóúñÑ\-.*’':%+/_ ]*$/;
export const PERUVIAN_VALID_PHONE = /^\d{9}$/;
export const FILE_NAME_REGX = /^[A-Za-z0-9ÁÉÍÓÚáéíóúñÑ\.\@\#\!\$\;\&\%\[\]\(\)\{\+\}\- ]+$/;
export const CODE_NAME_REGX = /^[A-Z0-9]+$/;
export const FIRST_CHARACTER_NO_BLANK_NO_NUMBER = /^[A-Za-z]/;
export const REMOVE_SPACES_REGEX = /\s{2}/g;
export const CURRENCY_REGEX = /^\d+(\.\d{2})?$/;
export const EMAIL_REGREX = /[a-zA-Z0-9-]{1,}@([a-zA-Z.])?[a-zA-Z]{1,}\.[a-zA-Z]{1,4}/gi;
export const ALPHANUMERIC_REGX = /^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ'’ ]*$/g;
export const ALPHANUMERIC_CHARACTER_SINGS_REGX = /^[A-Za-zÁÉÍÓÚáéíóúñÑ0-9\-_\._\*_\’_\'_\{_\%_\+_\}_\ _]*$/g;
export const ALPHANUMERIC_CHARACTER_REGX = /^[A-Za-z0-9\-_\._\*_\{_\}_\ _\u00C0-\u017F]*$/g;
export const ALPHANUMERIC_LIST_REGX = /^\s*([a-zA-Z0-9]+\s*,\s*){0,29}[a-zA-Z0-9]+\s*$/;
export const ALLOWED_NAME_STRING_REGEX = /^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ\-_/ ]+$/;
// Allow only alphanumeric characters and spaces. But no only spaces, no ñ, umlauts, tildes (lower and upper), point (when is number).
/**
 * Diacritical marks (accents/tildes/umlaut dots) from the string.
 * The Unicode range [\u0300-\u036f] covers most common accents.
 */
export const DIACRITICAL_MARKS_REGEX = /[\u0300-\u036f]/g;
/**
 * ### Ñ | ñ
 */
export const N_SPECIAL_REGEX = /ñ/gi;
export const ALPHANUMERIC_WITH_SPACES_REGEX = /[^a-z0-9\s]/gi;
export const ONLY_LETTERS_REGEX = /^[A-Za-zÁÉÍÓÚáéíóúÑñ'’ ]*$/g;
export const NO_SPECIAL_CHARACTER_REGEX = /^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ'’ ]*$/g;
export const VALID_NAME_SELLER_REGEX = /^[A-Za-zÁÉÍÓÚáéíóúñÑ\' ]*$/;
export const VALID_LASTNAME_SELLER_REGEX = /^[A-Za-zÁÉÍÓÚáéíóúñÑ\' ]*$/;
export const VALID_FFVV_SELLER_REGEX = /^[A-Za-z0-9\ ]*$/;
export const VALID_RULENAME_REGEX = /^[A-Za-z0-9ÁÉÍÓÚáéíóúñÑ\' ]*$/;
export const VALID_SLUG = /^[A-Za-z0-9\-\ ]*$/g;
export const INTEGERS_SEPARATED_BY_COMMAS = /^(\d+\s*,\s*)*\d+\s*,?$/;
export const URL_REGEX = /^https?:\/\/[\w.-]+\.[a-z]{2,}(\/.*)?$/i;
export const APP_URL_REGEX = /^(?:pu:\/\/[a-zA-Z0-9\-_/]+|https?:\/\/[\w.-]+\.[a-z]{2,}(\/.*)?)$/i;
export const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;
export const INTEGER_REGEX = /^\d+$/;
/**
 * ```javascript
 * 'ㅤ'
 * ```
 */
export const BLANK_INVISIBLE_SPACE_REGEX = /[\u3164]/g;
export const BLANK_SPACE_REGEX = /\s+/g;
export const TIME_24H_REGEX = /^\d{2}:\d{2}$/;
export const ALPHANUMERIC_LIST_WITH_COMMAS_REGEX = /^\s*([a-zA-Z0-9]+\s*,\s*)*[a-zA-Z0-9]+\s*$/;
